"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bannerWithInlineContent = require("./bannerWithInlineContent");

var _bannerWithInlineContent2 = _interopRequireDefault(_bannerWithInlineContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _bannerWithInlineContent2.default;